/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-props-no-spreading */
// @flow
import React, { type Node } from 'react';
import classnames from 'classnames';

import Button from '../Button';

import styles from './styles.module.scss';

type Props = {
  children?: Node,
  text: string,
  title: string,
  classNamePrompt?: string,
  className?: string,
  nameButton: string,
  positionType: 'bottom' | 'top' | '',
  handleButton: () => void,
  show: boolean,
  isPrompt?: boolean,
  zIndex: number,
  position?: number,
};

const TutorialMask = (
  {
    children,
    classNamePrompt = '',
    className = '',
    text,
    isPrompt = true,
    handleButton,
    position = 0,
    show,
    title,
    positionType = 'right',
    nameButton = 'Next',
    zIndex = 0,
  }: Props,
) => {
  const tutorialPromptRef = React.useRef(null);
  const tutorialChildrenRef = React.useRef(null);
  const widthTutorialPrompt = tutorialPromptRef?.current?.offsetWidth;
  const widthTutorialChildren = tutorialPromptRef?.current?.offsetWidth;
  const [width, setWidth] = React.useState('0');
  const handlerWidth = () => {
    if (!widthTutorialChildren && !widthTutorialPrompt) return;
    if (widthTutorialPrompt > widthTutorialChildren) {
      setWidth(widthTutorialPrompt);
      return;
    }
    setWidth(widthTutorialChildren);
  };

  React.useEffect(() => {
    if (!show) return;
    handlerWidth();
  }, [widthTutorialPrompt, widthTutorialChildren, show]);

  return (
    <div
      className={
        classnames(styles.tutorialMaskWrapper,
          { [styles.tutorialMaskWrapperShow]: show },
          className)
      }
      style={{ zIndex: show ? 1000 : zIndex }}
    >
      {
        isPrompt ? (
          <div className={classnames(styles.tutorialMask, { [styles.tutorialMaskShow]: show })}>
            <div
              className={
                classnames(
                  styles.tutorialPrompt,
                  { [styles.tutorialPromptHide]: !show },
                  classNamePrompt,
                )
              }
              ref={tutorialPromptRef}
              style={{ [positionType]: position || -width }}
            >
              <div className={styles.title}>
                {title}
              </div>
              <div className={styles.text}>{text}</div>
              <div className={styles.tutorialButtonWrapper}>
                <Button onClick={handleButton} small>
                  {nameButton}
                </Button>
              </div>
            </div>
          </div>
        ) : null
      }
      <div className={styles.tutorialChildren} ref={tutorialChildrenRef}>
        {children}
      </div>
    </div>
  );
};
export default TutorialMask;
